import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import { HOUSELINKS } from '../../../../data/constants'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>VERIFICATIONS</span>
        </div>
      </div>
      <AsideMenuItem
        to='/customers/person/verification'
        icon='/assets/media/icons/duotune/communication/com013.svg'
        title='Persons'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/customers/person/transactions'
        icon='/assets/media/icons/duotune/ecommerce/ecm001.svg'
        title='Transactions & Billing'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>SETTINGS</span>
        </div>
      </div>
      <AsideMenuItem
        to='/account/overview'
        icon='/assets/media/icons/duotune/communication/com014.svg'
        title='Account'
        fontIcon='bi-layers'
      />
    </>
  )
}
